import { render, staticRenderFns } from "./BettingBotPolling.vue?vue&type=template&id=c5a73b32&scoped=true&"
import script from "./BettingBotPolling.vue?vue&type=script&lang=js&"
export * from "./BettingBotPolling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a73b32",
  null
  
)

export default component.exports